import Compressor from "compressorjs";
import { END_POINTS, errorToast, getFromStorage, successToast } from "../helpers";
import { API_URL, MEDIA_URL, XMl_URL } from "../helpers/constants/urls";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { generateEncryptedKeyBody } from "./crypto";
import { CommonBody } from "../types/General";
import { useImportXmlMutation } from "../services/users";


interface UploadResponse {
  statusCode: number;
  data: any;
  message: string;
}

export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.8,
      success: async (compressedResult: any) => {
        const formData = new FormData();
        formData.append("file", compressedResult as any);
        // const encryptedFormData = generateEncryptedKeyBody(formData);
        let headers = {
          Accept: "application/json",
        };

        try {
          const res = await fetch(MEDIA_URL + END_POINTS?.uploadFiles, {
            method: "POST",
            headers,
            body: formData,
          });
          let response = await res.json();
          resolve(response); // Resolve the Promise with the response
        } catch (error) {
          //console.log(error, ">>>>>>>>>");
          reject(error); // Reject the Promise with the error
        }
      },
    });
  });
};
export const UploadVideo = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append("file", imageObject as any);
    let headers = {
      Accept: "application/json",
    };

    try {
      const res = await fetch(MEDIA_URL + END_POINTS.uploadFiles, {
        method: "POST",
        headers,
        body: formData,
      });
      let response = await res.json();
      resolve(response);
    } catch (error) {
      //console.log(error, ">>>>>>>>>");
      reject(error);
    }
  });
};

export const Uploadpdf = async (imageObject: any) => {
  const formData = new FormData();

  formData.append("file", imageObject as any);

  // const token = getToken ? JSON.parse(`${getToken}`) : null;
  let headers = {
    // "Content-Type": "multipart/form-data",
    Accept: "application/json",
  };
  try {
    const res = await fetch(MEDIA_URL + END_POINTS.uploadFiles, {
      method: "POST",
      headers,
      body: formData,
    });
    let response = await res.json();
    return response;
  } catch (error) {
    //console.log(error, ">>>>>>>>>");
    return error;
  }
};

export const UploadCsv = async (csvObject: any, id: any) => {
  const token = getFromStorage(STORAGE_KEYS.token);
  const formData = new FormData();

  formData.append("file", csvObject as any);
  formData.append("companyId", id);

  let headers = {
    // "Content-Type": "multipart/form-data",
    Accept: "application/json",
    Authorization: `Bearer ${token}`
  };
  try {
    const res = await fetch(XMl_URL, {
      method: "POST",
      headers,
      body: formData,
    });
    let response = await res.json();
    return response;




  } catch (error: any) {
    //console.log(error, ">>>>>>>>>");
    return error;
  }
};


export const handleDownload = async (fileUrl: string, fileName: string) => {
  try {
    const response = await fetch(fileUrl, { mode: "cors", cache: "no-cache" });
    // const response = await fetch(proxyUrl + fileUrl);
    if (!response.ok) throw new Error("Failed to fetch file");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${fileName}_${Date.now()}.${fileUrl.split(".").pop()}`;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
}


export const imgWatermark = async (
  imgFile: File,
  watermarkImageUrl: string,
  quality: number = 0.75,
  borderRadius: number = 0,
  tolerance: number = 40,
  watermarkScale: number = 0.05, // Reduced size to 10% of image width
): Promise<Blob> => {
  return new Promise(async (resolve, reject) => {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return reject('Failed to get canvas context');

    try {
      const originalImage = new Image();
      originalImage.src = URL.createObjectURL(imgFile);

      originalImage.onload = async () => {
        canvas.width = originalImage.width;
        canvas.height = originalImage.height;

        // Draw the original image onto the canvas
        context.drawImage(originalImage, 0, 0, canvas.width, canvas.height);

        // Fetch the watermark image
        const watermarkResponse = await fetch(watermarkImageUrl);
        if (!watermarkResponse.ok) {
          throw new Error('Failed to fetch watermark image.');
        }
        const watermarkBlob = await watermarkResponse.blob();
        const watermarkImage = await createImageBitmap(watermarkBlob);

        // Calculate watermark size (now 10% of image width)
        const watermarkWidth = canvas.width * watermarkScale;
        const watermarkHeight =
          (watermarkWidth / watermarkImage.width) * watermarkImage.height;

        // Position for the watermark
        const padding = canvas.width * 0.015; // 1.5% of image width for padding
        const watermarkX = canvas.width - watermarkWidth - padding;
        const watermarkY = canvas.height - watermarkHeight - padding;

        // Draw the watermark
        context.drawImage(
          watermarkImage,
          watermarkX,
          watermarkY,
          watermarkWidth,
          watermarkHeight,
        );

        // Convert to PNG to preserve transparency
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject('Failed to create watermarked image blob.');
            }
          },
          'image/png',
          quality,
        );
      };

      originalImage.onerror = () =>
        reject('Failed to load the original image from the provided file.');
    } catch (error: any) {
      reject(error.message);
    }
  });
};

// export const imgWatermark = async (
//   imgFile: File,
//   watermarkImageUrl: string,
//   quality: number = 0.75,
//   watermarkWidth: number = 400, // Increased default width
//   watermarkHeight: number = 300, // Increased default height
//   borderRadius: number = 0,
//   tolerance: number = 40,
// ): Promise<Blob> => {
//   return new Promise(async (resolve, reject) => {
//     const canvas: HTMLCanvasElement = document.createElement('canvas');
//     const context = canvas.getContext('2d');
//     if (!context) return reject('Failed to get canvas context');

//     try {
//       // Convert the input image file to an Image object
//       const originalImage = new Image();
//       originalImage.src = URL.createObjectURL(imgFile);

//       // Wait for the original image to load
//       originalImage.onload = async () => {

//         try {
//           canvas.width = originalImage.width;
//           canvas.height = originalImage.height;

//           // Draw the original image onto the canvas
//           context.drawImage(originalImage, 0, 0, canvas.width, canvas.height);

//           // Fetch the watermark image
//           const watermarkResponse = await fetch(watermarkImageUrl);
//           if (!watermarkResponse.ok) {
//             throw new Error('Failed to fetch watermark image.');
//           }
//           const watermarkBlob = await watermarkResponse.blob();

//           // Create an offscreen canvas for processing the watermark image
//           const offscreenCanvas = document.createElement('canvas');
//           const offscreenContext = offscreenCanvas.getContext('2d');
//           if (!offscreenContext)
//             return reject('Failed to get offscreen canvas context');

//           // Set the offscreen canvas size
//           offscreenCanvas.width = watermarkWidth;
//           offscreenCanvas.height = watermarkHeight;

//           // Draw the watermark onto the offscreen canvas
//           const watermarkImage = await createImageBitmap(watermarkBlob);
//           offscreenContext.drawImage(
//             watermarkImage,
//             0,
//             0,
//             watermarkWidth,
//             watermarkHeight,
//           );

//           // Get image data for processing
//           const imageData = offscreenContext.getImageData(
//             0,
//             0,
//             watermarkWidth,
//             watermarkHeight,
//           );
//           const data = imageData.data;

//           // Sample corners to determine background color
//           const getPixelAt = (x: number, y: number) => {
//             const index = (y * watermarkWidth + x) * 4;
//             return {
//               r: data[index],
//               g: data[index + 1],
//               b: data[index + 2],
//             };
//           };

//           // Sample more points for better background detection
//           const samplePoints = [
//             getPixelAt(0, 0), // Top-left
//             getPixelAt(watermarkWidth - 1, 0), // Top-right
//             getPixelAt(0, watermarkHeight - 1), // Bottom-left
//             getPixelAt(watermarkWidth - 1, watermarkHeight - 1), // Bottom-right
//             getPixelAt(Math.floor(watermarkWidth / 2), 0), // Top-middle
//             getPixelAt(0, Math.floor(watermarkHeight / 2)), // Middle-left
//           ];

//           // Calculate average background color
//           const bgColor = {
//             r:
//               samplePoints.reduce((sum, c) => sum + c.r, 0) / samplePoints.length,
//             g:
//               samplePoints.reduce((sum, c) => sum + c.g, 0) / samplePoints.length,
//             b:
//               samplePoints.reduce((sum, c) => sum + c.b, 0) / samplePoints.length,
//           };

//           // Process image data for clean background removal
//           for (let i = 0; i < data.length; i += 4) {
//             const r = data[i];
//             const g = data[i + 1];
//             const b = data[i + 2];

//             // Calculate color difference using Euclidean distance
//             const colorDiff = Math.sqrt(
//               Math.pow(r - bgColor.r, 2) +
//               Math.pow(g - bgColor.g, 2) +
//               Math.pow(b - bgColor.b, 2),
//             );

//             if (colorDiff < tolerance) {
//               data[i + 3] = 0; // Make background fully transparent
//             } else if (colorDiff < tolerance * 1.2) {
//               // Smooth edges slightly
//               const alpha = Math.floor(
//                 (255 * (colorDiff - tolerance)) / (tolerance * 0.2),
//               );
//               data[i + 3] = alpha;
//             }
//           }

//           // Put the modified image data back
//           offscreenContext.putImageData(imageData, 0, 0);

//           // Position for the watermark (adjusted for larger size)
//           const padding = 40; // Increased padding for larger watermark
//           const watermarkX = canvas.width - watermarkWidth - padding;
//           const watermarkY = canvas.height - watermarkHeight - padding;

//           // Draw the processed watermark
//           context.drawImage(
//             offscreenCanvas,
//             watermarkX,
//             watermarkY,
//             watermarkWidth,
//             watermarkHeight,
//           );

//           // Convert to PNG to preserve transparency
//           canvas.toBlob(
//             (blob) => {
//               if (blob) {
//                 resolve(blob);
//               } else {
//                 reject('Failed to create watermarked image blob.');
//               }
//             },
//             'image/png',
//             quality,
//           );


//         } catch (error: any) {
//           errorToast("Something went wrong")
//         }



//       };

//       originalImage.onerror = () =>
//         reject('Failed to load the original image from the provided file.');
//     } catch (error: any) {
//       reject(error.message);
//     }
//   });
// };